export default __webpack_public_path__ + "static/media/app_store.9bc6575d.png";